import React from "react";

type EntranceIconProps = {
  colour?: string;
  width?: number;
  height?: number;
};

export const EntranceIcon: React.FC<EntranceIconProps> = ({
  colour = "white",
  width,
  height,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 200 100"
      xmlns="http://www.w3.org/2000/svg"
      style={{ backgroundColor: "none" }}
    >
      <title>Main Door Icon</title>
      {/* Door Frame (Top line is dashed, bottom line removed) */}
      <line
        x1="0"
        y1="0"
        x2="100"
        y2="0"
        stroke={colour}
        strokeWidth="5"
        strokeDasharray="2.5,2.5"
      />
      <line x1="0" y1="0" x2="0" y2="50" stroke={colour} strokeWidth="5" />
      <line x1="100" y1="0" x2="100" y2="50" stroke={colour} strokeWidth="5" />

      {/* Swing Arches (connected to top line) */}
      <path
        d="M 50,0 A 50 50 0 0 1 0 50"
        fill="none"
        stroke={colour}
        strokeWidth="5.5"
      />
      <path
        d="M 50,0 A 50 50 0 0 0 100 50"
        fill="none"
        stroke={colour}
        strokeWidth="5.5"
      />

      {/* Hinges */}
      <line x1="0" y1="22.5" x2="0" y2="27.5" stroke={colour} strokeWidth="5" />
      <line
        x1="100"
        y1="22.5"
        x2="100"
        y2="27.5"
        stroke={colour}
        strokeWidth="5"
      />
    </svg>
  );
};
